import { gql } from '@apollo/client';

export default gql`
  mutation sendAllUsersNotification(
    $subject: String!
    $message: String!
    $scope: AttachmentScope!
    $recipients: [String]
  ) {
    sendAllUsersNotification(
      input: {
        subject: $subject
        message: $message
        scope: $scope
        recipients: $recipients
      }
    )
  }
`;
